module.exports = __webpack_public_path__ + "static/img/mypage_logo.c9aa3d1b.svg";